import React, {
    createContext,
    useEffect,
    useState,
    useContext,
  } from "react";
  
  //CONSTANT
  import { ACTION_EVENT } from "../constant/event";
  import {
    BUNDLE_APP_NAME,
    GET_APP_DOMAIN_LIST,
    GET_APP_NAME,
    IS_BUNDLE_APP,
    BUNDLE_ARTICLES,
    GET_APP_NAME_FOR_COLLECTION,
    APP_BUNDLES,
    IS_VISIBLE_COMMUNITY,
  } from "../../app_constant";
  import { STRING } from "../constant";
  
  //API
  import { UPDATE_SUBSCRIPTION, UPDATE_COMMUNITY_DATA } from "../api/community";
  import {
    GET_STRIPE_DETAILS,
    GET_USER_STRIPE_ONE_TIME_PAYMENT,
    UPDATE_USER_SUBSCRIPTION,
    GET_REVENUECAT_EVENTS,
    GET_REVENUECAT_METADATA,
    GET_REVENUECAT_SUBSCRIPTION_PLAN,
    UPDATE_NOTIFICATION_SETTING,
    UPDATE_PROFILE_DETAILS,
    UPDATE_USER_FONTS_OPTIONS,
    UPDATE_USER_PROFILE,
    UPDATE_USER_TEST_OPTIONS,
    UPDATE_BUNDLE_PROFILE_DETAILS,
    UPDATE_BUNDLE_USER_PROFILE,
  } from "../api/firebase_user";
  import { GET_SCORE_QUESTIONS, SAVE_QUESTION, SAVE_PROGRESS_DASHBOARD, SAVE_SCORE_PROGRESS, SAVE_QUESTION_BOOKMARK, SAVE_QUESTION_PROGRESS } from "../api/questions";
  import {
    GET_ACCESS_CODE_DETAILS,
    UPDATE_ACCESS_CODE_REDEEM,
  } from "../api/access_code";
  import {
    SAVE_FLASHCARD_BOOKMARK,
    SAVE_FLASHCARD_PROGRESS,
  } from "../api/flashcard";
  import {
    SAVE_ARTICLE_BOOKMARK,
    SAVE_ARTICLE_PROGRESS,
    GET_ARTICLE_BOOKMARKS,
    MARK_ARTICLE_AS_READ,
    GET_ARTICLE_READ_STATUS,
    GET_ARTICLE_READ_SUMMARY,
    GET_READ_ARTICLES_BY_TOPIC,
    SAVE_ARTICLE_REACTION,
    GET_ARTICLE_REACTION_SUMMARY,
  } from "../api/articles";
  import { DELETE_TEST_HISTORY, SAVE_TEST_HISTORY } from "../api/practice";
  import {
    UPDATE_USER_QOTD,
    GET_USER_QOTD_SUMMARY,
    GET_USER_QOTD_RESPONSE,
    GET_USER_QOTD_RESPONSES,
  } from "../api/qotd";
  
  //CONTENT
  import { GET_ARTICLES, GET_FLASHCARDS, GET_LOCAL_QUESTIONS, GET_ACRONYMS, GET_GLOSSARY } from "../api/content";
  
  //CONTEXT
  import { BundleContext } from "./BundleProvider";
  
  //PACKAGES
  import { auth, firestore } from "../api/config";
  import { usePostHog } from 'posthog-js/react';
import { isGhostMode, getGhostUid, getEffectiveUid } from "../api/ghostUid";
import moment from "moment";
import _ from "lodash";
import { getTodayLocal } from "../utils/dates";

//CORE BUSINESS LOGIC (Shared with mobile)
/* import {
  calculateReadinessScores,
  normalizeExpirationDate,
  isSubscriptionActive,
  isSubscriptionMetadataComplete,
  getPlanFromInterval,
  createEmptyProfile as createEmptyProfileCore,
  createEmptyArticlesData as createEmptyArticlesDataCore,
  createEmptyQOTDData as createEmptyQOTDDataCore,
  createEmptyBundleData,
  createEmptyCommunityData
} from "../../lzapps_core_code/business/authProvider"; */

const collection = async () => {
  const APP_NAME = await GET_APP_NAME_FOR_COLLECTION();
  return firestore()
    .collection("apps")
    .doc(APP_NAME)
    .collection("users")
    .doc(getEffectiveUid());
};

export const AuthContext = createContext();
  
  export const AuthProvider = (props) => {
    const { selectedCertificate } = useContext(BundleContext);
    const posthog = usePostHog();
  
    // Get initial profile data from localStorage
    const getInitialProfileData = () => {
      const userdata = localStorage.getItem("userData");
      const data = JSON.parse(userdata) || null;
      return data || {
        auth_email: "",
        auth_first_name: "",
        auth_last_name: "",
        auth_login_provider: "",
        last_signin_time: "",
        flashcard_bookmarks: [],
        flashcards_progress: [],
        practice_test_history: [],
        question_bookmarks: [],
        questions_progress: [],
        articles_progress: [],
        quiz_of_the_day_reminder: true,
        signup_date: "",
        study_plan_reminder: true,
        profile_pic: "",
        readiness_scores: null,
        score_progress: {},
      };
    };

    // Get initial articles data from localStorage
    const getInitialArticlesData = () => {
      const articlesData = localStorage.getItem("articlesData");
      const data = JSON.parse(articlesData) || null;
      return data || {
        bookmarks: [],
        readSummary: {
          total_articles_read: 0,
          total_read_count: 0,
          last_read_at: null,
          articles_by_topic: {}
        },
        reactionSummary: {
          total_articles_liked: 0,
          total_articles_disliked: 0,
          last_reaction_at: null,
          reactions_by_topic: {}
        }
      };
    };

    // Get initial QOTD data from localStorage
    const getInitialQOTDData = () => {
      const qotdData = localStorage.getItem("qotdData");
      const data = JSON.parse(qotdData) || null;
      return data || {
        summary: {
          current_streak: 0,
          best_streak: 0,
          total_answered: 0,
          total_correct: 0,
          last_qotd_date: null
        },
        responses: {}
      };
    };

    // State declarations
    const [profile, setProfileState] = useState(getInitialProfileData());
    const [articles, setArticlesState] = useState(getInitialArticlesData());
    const [qotd, setQOTDState] = useState(getInitialQOTDData());
    const [bundleData, setBundleDataState] = useState({
      auth_email: "",
      auth_first_name: "",
      auth_last_name: "",
      auth_login_provider: "",
      last_signin_time: "",
    });
    const [community, setCommunityState] = useState({
      questions_version: 1,
      total_time_per_question: 90,
      is_forcefully_new_version: false,
      android_app_verions: null,
      android_build_number: null,
      ios_app_version: null,
      ios_build_number: null,
    });
    const [questionScrore, setQuestionScoreState] = useState({
      all_questions_scrores: [],
    });
  
    const [questionsList, setQuestionsList] = useState([]);
    const [articlesList, setArticlesList] = useState([]);
    const [flashCardsList, setFlashCardsList] = useState([]);
    const [acronymsList, setAcronymsList] = useState([]);
    const [glossaryList, setGlossaryList] = useState([]);
    const [isSubscribe, setSubscription] = useState(false);
    const [isVisibleCommunity, setVisibleCommunity] = useState(IS_VISIBLE_COMMUNITY);
    
    // Authentication loading state
    const [isAuthLoading, setIsAuthLoading] = useState(true);
  
    // Helper function to update localStorage when profile changes
    const updateLocalStorage = (newProfile) => {
      localStorage.setItem("userData", JSON.stringify(newProfile));
    };

    // Helper function to update articles localStorage
    const updateArticlesLocalStorage = (newArticles) => {
      localStorage.setItem("articlesData", JSON.stringify(newArticles));
    };

    // Helper function to update QOTD localStorage
    const updateQOTDLocalStorage = (newQOTD) => {
      localStorage.setItem("qotdData", JSON.stringify(newQOTD));
    };

    // Helper function to clear user-specific localStorage data
    const clearUserLocalStorage = () => {
      localStorage.removeItem("userData");
      localStorage.removeItem("articlesData");
      localStorage.removeItem("qotdData");
    };
  
    // Helper function to calculate readiness scores
    const calculateReadinessScores = (scores, questionsList, appDomains) => {
      const total_question = questionsList.length;
      const questions_answered = scores.filter(i => i.times_answered >= 1).length;
      const questions_correct = scores.filter(i => i.score >= 1).length;
      const total_accuracy_score = _.sumBy(scores, "accuracy_score");
      const accuracy_score_percentage = total_accuracy_score / questions_answered;
      const completeness_score_percentage = questions_answered / total_question;
  
      var topicProgress = [];
      for (let index in appDomains) {
        const domain = appDomains[index];
        const topic_total = questionsList?.filter(e => e.topic_id == domain.id).length;
        const topic_score_list = scores.filter(i => i.topic_id == domain.id);
        const topic_questions_answered = topic_score_list.filter(i => i.times_answered >= 1).length;
        const topic_questions_correct = topic_score_list.filter(i => i.score >= 1).length;
        const topic_total_accuracy_score = _.sumBy(topic_score_list, "accuracy_score");
        const topic_accuracy_score_percentage = topic_total_accuracy_score / topic_questions_answered;
        const topic_completeness_score_percentage = topic_questions_answered / topic_total;
        const readiness_score = (topic_accuracy_score_percentage * 0.7 + topic_completeness_score_percentage * 0.3) * 100;
        
        const topicObj = {
          domain_name: domain.domain_name,
          domain_id: domain.id,
          total_questions: topic_total,
          questions_answered: topic_questions_answered,
          questions_correct: topic_questions_correct,
          questions_incorrect: topic_questions_answered - topic_questions_correct,
          total_accuracy_score: topic_total_accuracy_score,
          accuracy_score_percentage: topic_accuracy_score_percentage,
          completeness_score_percentage: topic_completeness_score_percentage,
          readiness_score: isNaN(readiness_score) ? 0 : readiness_score,
        };
        topicProgress.push(topicObj);
      }
  
      return {
        total_questions: total_question,
        questions_answered: questions_answered,
        questions_correct: questions_correct,
        questions_incorrect: questions_answered - questions_correct,
        total_accuracy_score: total_accuracy_score,
        accuracy_score_percentage: accuracy_score_percentage,
        completeness_score_percentage: completeness_score_percentage,
        readiness_score: (accuracy_score_percentage * 0.7 + completeness_score_percentage * 0.3) * 100,
        topic_progress: topicProgress,
      };
    };
  
    // Get score questions on mount
    async function getScoreQuestions() {
      const result = await GET_SCORE_QUESTIONS();
      setAllQuestionData(result?.data ?? []);
      setQuestionScoreState({
        all_questions_scrores: result?.data ?? [],
      });
      return { data: result?.data ?? [], exist: result.isExist };
    }
  
    useEffect(() => {
      getScoreQuestions();
    }, []);
  
    // Firebase listeners
    useEffect(() => {
      const uid = isGhostMode() ? getGhostUid() : auth().currentUser?.uid;
      const unsubscribe = firestore()
        .collection("customers")
        .doc(uid)
        .collection("subscriptions")
        .onSnapshot((snapshot) => {
          const updateData = [];
          snapshot.forEach((doc) => {
            updateData.push({ id: doc.id, ...doc.data() });
          });
        });
      return () => unsubscribe();
    }, []);
  
    useEffect(() => {
      const QUESTIONS_LIST = GET_LOCAL_QUESTIONS(selectedCertificate);
      setQuestionsList(QUESTIONS_LIST);
      
      const ARTICLES_LIST = GET_ARTICLES(selectedCertificate);
      setArticlesList(ARTICLES_LIST);

      const FLASH_CARDS_LIST = GET_FLASHCARDS(selectedCertificate);
      setFlashCardsList(FLASH_CARDS_LIST);

      const ACRONYMS_LIST = GET_ACRONYMS(selectedCertificate);
      setAcronymsList(ACRONYMS_LIST);

      const GLOSSARY_LIST = GET_GLOSSARY(selectedCertificate);
      setGlossaryList(GLOSSARY_LIST);
    }, [selectedCertificate]);
  
    useEffect(() => {
      const unsubscribeAuth = auth().onAuthStateChanged((user) => {
        // Set loading to false once we get the auth state
        setIsAuthLoading(false);
        // console.log('[AuthProvider] onAuthStateChanged:', user ? 'User logged in' : 'User logged out');

        if (user) {
          // Identify user in PostHog so events are linked to their profile
          if (posthog) {
            posthog.identify(user.uid, {
              email: user.email,
              name: user.displayName,
              app_name: BUNDLE_APP_NAME,
            });
          }

          const effectiveUid = isGhostMode() ? getGhostUid() : user.uid;
          const bundle = APP_BUNDLES.find(b => b.key === selectedCertificate);
          const APP_NAME = bundle ? bundle.bundle_firebase_collection_name : GET_APP_NAME(selectedCertificate);

          const unsubscribeProfile = firestore()
            .collection("apps")
            .doc(APP_NAME)
            .collection("users")
            .doc(effectiveUid)
            .onSnapshot((snapshot) => {
              if (snapshot.exists) {
                const data = snapshot.data();
                setProfile(data);

                // Save country_code if not already in profile (skip in ghost mode)
                if (data.article_bookmarks !== undefined) {
                  setArticlesState((prev) => {
                    const updated = {
                      ...prev,
                      bookmarks: data.article_bookmarks || [],
                    };
                    updateArticlesLocalStorage(updated);
                    return updated;
                  });
                }
                if (!IS_BUNDLE_APP) {
                  getSubscriptionDetails(data);
                }
              }
            });

          const unsubscribeQuestions = firestore()
            .collection("apps")
            .doc(APP_NAME)
            .collection("users")
            .doc(effectiveUid)
            .collection("questions")
            .onSnapshot((querySnapshot) => {
              const questions = [];
              querySnapshot.forEach((doc) => {
                questions.push(doc.data());
              });
              setQuestions(questions);
            });

          // Articles real-time listeners
          const unsubscribeArticles = firestore()
            .collection("apps")
            .doc(APP_NAME)
            .collection("users")
            .doc(effectiveUid)
            .collection("articles")
            .onSnapshot((querySnapshot) => {
              // Preserve existing state to avoid resetting progress that hasn't been saved to Firestore yet
              setArticlesState((prevArticles) => {
                const newArticles = {
                  bookmarks: prevArticles?.bookmarks || [],
                  readSummary: prevArticles?.readSummary || {
                    total_articles_read: 0,
                    total_read_count: 0,
                    last_read_at: null,
                    articles_by_topic: {}
                  },
                  reactionSummary: prevArticles?.reactionSummary || {
                    total_articles_liked: 0,
                    total_articles_disliked: 0,
                    last_reaction_at: null,
                    reactions_by_topic: {}
                  }
                };

                querySnapshot.forEach((doc) => {
                  const data = doc.data();
                  switch (doc.id) {
                    case "article_read_summary":
                      newArticles.readSummary = {
                        total_articles_read: data.total_articles_read || 0,
                        total_read_count: data.total_read_count || 0,
                        last_read_at: data.last_read_at || null,
                        articles_by_topic: data.articles_by_topic || {}
                      };
                      break;
                    case "article_reaction_summary":
                      newArticles.reactionSummary = {
                        total_articles_liked: data.total_articles_liked || 0,
                        total_articles_disliked: data.total_articles_disliked || 0,
                        last_reaction_at: data.last_reaction_at || null,
                        reactions_by_topic: data.reactions_by_topic || {}
                      };
                      break;
                    default:
                      // Handle individual article read status documents
                      if (data.article_id) {
                        // This is an individual article read status
                        // We could store this in readSummary.articles_by_topic if needed
                      }
                      break;
                  }
                });

                updateArticlesLocalStorage(newArticles);
                return newArticles;
              });
            });

          // QOTD real-time listeners - Optimized to only load summary and today's response
          const today = getTodayLocal(); // Use local timezone date
          
          // Reset QOTD state when exam changes
          setQOTDState(getInitialQOTDData());
          
          // Add debug info to state
          setQOTDState(prev => ({
            ...prev,
            _debug: {
              today,
              appName: APP_NAME,
              timestamp: new Date().toISOString(),
              collectionPath: `apps/${APP_NAME}/users/${effectiveUid}/qotd`,
              listenerSetup: true
            }
          }));
          
          // Listen to summary document
          const unsubscribeQOTDSummary = firestore()
            .collection("apps")
            .doc(APP_NAME)
            .collection("users")
            .doc(effectiveUid)
            .collection("qotd")
            .doc("summary")
            .onSnapshot((doc) => {
              if (doc.exists) {
                const data = doc.data();
                setQOTDState(prev => ({
                  ...prev,
                  summary: {
                    current_streak: data.current_streak || 0,
                    best_streak: data.best_streak || 0,
                    total_answered: data.total_answered || 0,
                    total_correct: data.total_correct || 0,
                    last_qotd_date: data.last_qotd_date || null
                  },
                  _debug: {
                    ...prev._debug,
                    summaryExists: true,
                    summaryData: data
                  }
                }));
              } else {
                // Summary document doesn't exist for this exam, reset to initial state
                setQOTDState(prev => ({
                  ...prev,
                  summary: {
                    current_streak: 0,
                    best_streak: 0,
                    total_answered: 0,
                    total_correct: 0,
                    last_qotd_date: null
                  },
                  _debug: {
                    ...prev._debug,
                    summaryExists: false,
                    summaryData: null
                  }
                }));
              }
            });

          // Listen to today's response only (exclude summary document)
          const unsubscribeQOTDResponses = firestore()
            .collection("apps")
            .doc(APP_NAME)
            .collection("users")
            .doc(effectiveUid)
            .collection("qotd")
            .where('date', '>=', today) // Only load today and future responses
            .onSnapshot((querySnapshot) => {
              const newResponses = {};
              const debugData = [];
              
              querySnapshot.forEach((doc) => {
                const data = doc.data();
                debugData.push({ docId: doc.id, data });
                
                // Only process documents that have a date field (actual responses, not summary)
                if (data.date && data.date >= today && doc.id !== "summary") {
                  // Only load today's and future responses
                  newResponses[doc.id] = {
                    date: data.date,
                    isCorrect: data.isCorrect,
                    timeSpent: data.timeSpent || 0,
                    answered_at: data.answered_at,
                    ...data
                  };
                }
              });

              setQOTDState(prev => ({
                ...prev,
                responses: newResponses,
                _debug: {
                  ...prev._debug,
                  responsesQuerySize: querySnapshot.size,
                  responsesLoaded: Object.keys(newResponses).length,
                  allQueryData: debugData,
                  lastQueryTime: new Date().toISOString(),
                  queryFilter: `date >= ${today}`
                }
              }));
              updateQOTDLocalStorage({
                summary: qotd?.summary || {
                  current_streak: 0,
                  best_streak: 0,
                  total_answered: 0,
                  total_correct: 0,
                  last_qotd_date: null
                },
                responses: newResponses
              });
            });

          let unsubscribeBundle = null;
          if (IS_BUNDLE_APP) {
            unsubscribeBundle = firestore()
              .collection("apps")
              .doc(BUNDLE_APP_NAME)
              .collection("users")
              .doc(effectiveUid)
              .onSnapshot((snapshot) => {
                if (snapshot.exists) {
                  setBundleProfile(snapshot.data());
                  getSubscriptionDetails(snapshot.data());
                }
              });
          }

          return () => {
            unsubscribeProfile();
            unsubscribeQuestions();
            unsubscribeArticles();
            unsubscribeQOTDSummary();
            unsubscribeQOTDResponses();
            unsubscribeBundle && unsubscribeBundle();
          };
        } else {
          // User signed out - clear all user data
          setProfileState(null);
          setBundleDataState(null);
          setQuestionScoreState({ all_questions_scrores: [] });
          setArticlesList([]);
          setQOTDState(getInitialQOTDData());
          setSubscription(false);
          setVisibleCommunity(IS_VISIBLE_COMMUNITY);
          clearUserLocalStorage();
        }
      });

      return () => unsubscribeAuth();
    }, [selectedCertificate]);
  
    // Utility functions for subscription management
    const normalizeExpirationDate = (expirationDate) => {
      let expirationMs = new Date(expirationDate).getTime();
      return expirationMs < 1e12 ? expirationMs * 1000 : expirationMs;
    };
  
    const isSubscriptionActive = (expirationDate) => {
      return normalizeExpirationDate(expirationDate) > Date.now();
    };
  
    const isSubscriptionMetadataComplete = (subscription) => {
      return subscription?.paymentMode && 
             subscription?.paymentType && 
             subscription?.plan;
    };
  
    const updateSubscription = async (data) => {
      await UPDATE_USER_SUBSCRIPTION({ subscription: data });
      setSubscription(true);
    };
  
    const checkRevenueCatSubscription = async () => {
      const name = await GET_APP_NAME();
      const appName = IS_BUNDLE_APP ? BUNDLE_APP_NAME : name;
      const metadata = await GET_REVENUECAT_METADATA(appName);
      
      if (!metadata.status) return false;
      if (!metadata?.data?.length) return false;
  
      const allProductIds = metadata.data.map(item => item.id);
      const events = await GET_REVENUECAT_EVENTS();
  
      if (!events?.status || events?.data?.length === 0) return false;
  
      const eventForThisApp = events.data.filter((e) => allProductIds.includes(e.product_id));
      if (eventForThisApp.length === 0) {
        return false;
      }
      const latestEvent = eventForThisApp.sort((a, b) => b.event_timestamp_ms - a.event_timestamp_ms)[0];
      const expirationDate = latestEvent.expiration_at_ms;
      
      if (!isSubscriptionActive(expirationDate)) return false;
  
      const planResult = await GET_REVENUECAT_SUBSCRIPTION_PLAN(latestEvent.product_id);
      if (!planResult.status) {
          console.error(planResult.error);
          return false;
      }
      
      await updateSubscription({
          subscription_expiration: expirationDate,
          paymentMode: latestEvent.store,
          paymentType: "recurring",
          plan: planResult.data
      });
      
      return true;
    }; 
  
    const checkStripeSubscription = async () => {
      const uid = isGhostMode() ? getGhostUid() : auth().currentUser?.uid;
      if (!uid) return false;

      const resStripe = await GET_STRIPE_DETAILS(uid);
      if (!resStripe?.data) return false;
  
      const activeSubscription = resStripe.data.find(ele => ele.status === "active");
      if (!activeSubscription) return false;
  
      const expirationDate = normalizeExpirationDate(activeSubscription.current_period_end.toDate());
      
      if (!isSubscriptionActive(expirationDate)) return false;
  
       const { interval, interval_count } = activeSubscription.priceDetails;
       const plan = getPlanFromInterval(interval, interval_count);
  
       await updateSubscription({
         subscription_expiration: expirationDate,
         paymentMode: "stripe",
         paymentType: "recurring",
         plan: plan
       });
  
       return true;
    }; 
  
    const getPlanFromInterval = (interval, intervalCount) => {
      interval = interval.toLowerCase();
      if (interval === 'month') {
          if (intervalCount === 1) return 'Monthly';
          if (intervalCount === 3) return 'Quarterly';
          if (intervalCount === 6) return 'Semi-Annual';
      }
      if (interval === 'year') return 'Annual';
      return `${intervalCount} ${interval}(s)`;
    };
  
    const checkStripeOneTimePayment = async () => {
      const uid = isGhostMode() ? getGhostUid() : auth().currentUser?.uid;
      if (!uid) return false;

      const oneTimePayment = await GET_USER_STRIPE_ONE_TIME_PAYMENT(uid);
      const successfulOneTimePayments = oneTimePayment?.data?.filter(ele => 
          ele?.status === "succeeded" &&
          ele?.description !== "Subscription creation" &&
          ele?.description !== "Subscription update"
      );
  
      if (!successfulOneTimePayments?.length) return false;
  
      const latestPayment = successfulOneTimePayments[0];
      const createdTime = normalizeExpirationDate(latestPayment.created);
      const periodMonths = parseInt(latestPayment.priceData?.description, 10);
  
      if (isNaN(periodMonths)) return false;
  
      const expirationDate = new Date(createdTime);
      expirationDate.setMonth(expirationDate.getMonth() + periodMonths);
  
      if (!isSubscriptionActive(expirationDate)) return false;
  
      await updateSubscription({
          subscription_expiration: expirationDate.getTime(),
          paymentMode: "stripe",
          paymentType: "one_time",
          plan: `${periodMonths}-month`
      });
  
      return true;
    };
  
    async function getSubscriptionDetails(result) {
      try {
          let isSubscribed = false;
          const currentSubscription = result?.subscription;
  
          // Check if subscription is active and has complete metadata
          if (currentSubscription?.subscription_expiration) {
              isSubscribed = isSubscriptionActive(currentSubscription.subscription_expiration);
              
              // If subscription is active but missing metadata, run checks to update the fields
              if (isSubscribed && !isSubscriptionMetadataComplete(currentSubscription)) {
                  await checkRevenueCatSubscription() ||
                  await checkStripeSubscription() ||
                  await checkStripeOneTimePayment();
              }
          }
  
          // If not subscribed or subscription expired, run all checks
          if (!isSubscribed) {
              isSubscribed = await checkRevenueCatSubscription() ||
                            await checkStripeSubscription() ||
                            await checkStripeOneTimePayment();
          }
  
          setSubscription(isSubscribed);
          return isSubscribed;
      } catch (err) {
          console.error('Subscription check failed:', err);
          setSubscription(false);
          return false;
      }
    }
  
    // Profile management functions
    function setProfile(data) {
      const newProfile = { ...data };
      setProfileState(newProfile);
      updateLocalStorage(newProfile);
  
      // Handle score progress - only save if today's score has changed
      const todayKey = moment().format("YYYY-MM-DD");
      const currentScore = newProfile?.readiness_scores?.readiness_score ?? 0;
      const existingScore = newProfile?.score_progress?.[todayKey];

      if (existingScore !== currentScore) {
        if (newProfile?.score_progress) {
          const updatedScoreProgress = {
            ...newProfile.score_progress,
            [todayKey]: currentScore
          };
          SAVE_SCORE_PROGRESS(updatedScoreProgress);
        } else {
          const item = {
            [todayKey]: currentScore,
          };
          SAVE_SCORE_PROGRESS(item);
        }
      }
    }
  
    function setQuestions(questions) {
      setQuestionScoreState({
        all_questions_scrores: questions ?? [],
      });
    }
  
    function setArticles(articles) {
      setArticlesList(articles);
    }
  
    function setBundleProfile(data) {
      setBundleDataState(data);
    }
  
    function setNewProfile(data) {
      const newProfile = { ...data };
      setProfileState(newProfile);
      updateLocalStorage(newProfile);
      UPDATE_USER_PROFILE(data);
    }
  
    function setNewBundleProfile(data) {
      setBundleDataState(data);
      UPDATE_BUNDLE_USER_PROFILE(data);
    }
  
    function setNotification(quiz, study) {
      const updatedProfile = {
        ...profile,
        quiz_of_the_day_reminder: quiz ?? true,
        study_plan_reminder: study ?? true,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      UPDATE_NOTIFICATION_SETTING(
        updatedProfile.quiz_of_the_day_reminder,
        updatedProfile.study_plan_reminder
      );
    }
  
    function setProfileDetails(firstName, lastName) {
      if (IS_BUNDLE_APP) {
        const updatedBundleData = {
          ...bundleData,
          auth_first_name: firstName ?? "",
          auth_last_name: lastName ?? "",
        };
        setBundleDataState(updatedBundleData);
        UPDATE_BUNDLE_PROFILE_DETAILS(firstName, lastName);
      } else {
        const updatedProfile = {
          ...profile,
          auth_first_name: firstName ?? "",
          auth_last_name: lastName ?? "",
        };
        setProfileState(updatedProfile);
        updateLocalStorage(updatedProfile);
        UPDATE_PROFILE_DETAILS(firstName, lastName);
      }
    }
  
    function setProfilePicture(url) {
      const updatedProfile = {
        ...profile,
        profile_pic: url ?? "",
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
    }
  
    function setBundleProfilePicture(url) {
      const updatedBundleData = {
        ...bundleData,
        profile_pic: url ?? "",
      };
      setBundleDataState(updatedBundleData);
    }
  
    function setTestOptions(time_per_question, allow_go_back) {
      const updatedProfile = {
        ...profile,
        time_per_question: time_per_question ?? 90,
        allow_go_back: allow_go_back ?? true,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      UPDATE_USER_TEST_OPTIONS(time_per_question, allow_go_back);
    }
  
    function setFontsOptions(font_size) {
      const updatedProfile = {
        ...profile,
        font_size: font_size ?? 1,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      UPDATE_USER_FONTS_OPTIONS(font_size);
    }
  
    async function setTestHistory(data) {
      console.log('🔍 [DEBUG] setTestHistory called');
      console.log('🔍 [DEBUG] setTestHistory input data:', data);
      console.log('🔍 [DEBUG] setTestHistory current profile:', profile);
      console.log('🔍 [DEBUG] setTestHistory profile.practice_test_history:', profile?.practice_test_history);
      
      const history = profile?.practice_test_history ? [...profile.practice_test_history] : [];
      console.log('🔍 [DEBUG] setTestHistory existing history length:', history.length);
      
      history.push(data);
      console.log('🔍 [DEBUG] setTestHistory updated history length:', history.length);
      console.log('🔍 [DEBUG] setTestHistory final history:', history);
      
      const updatedProfile = {
        ...profile,
        practice_test_history: history,
      };
      console.log('🔍 [DEBUG] setTestHistory updatedProfile:', updatedProfile);
      
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      
      // Use arrayUnion to add the single test data directly
      console.log('🔍 [DEBUG] setTestHistory using arrayUnion to add test data');
      try {
        const collection_user = await collection();
        await collection_user.update({
          practice_test_history: firestore.FieldValue.arrayUnion(data),
        });
        console.log('✅ [DEBUG] setTestHistory arrayUnion successful');
      } catch (error) {
        console.error('❌ [DEBUG] setTestHistory arrayUnion failed:', error);
      }
      console.log('✅ [DEBUG] setTestHistory completed');
    }
  
    function deleteTestHistory(data) {
      let history = _.cloneDeep(profile.practice_test_history);
      history = history.filter(item => JSON.stringify(item) != JSON.stringify(data));
      const updatedProfile = {
        ...profile,
        practice_test_history: history,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      DELETE_TEST_HISTORY(data);
    }
  
    function addFlashcardToBookmark(id) {
      let bookmarks = _.cloneDeep(profile.flashcard_bookmarks);
      if (bookmarks) {
        bookmarks.push(id);
      } else {
        bookmarks = [id];
      }
      const updatedProfile = {
        ...profile,
        flashcard_bookmarks: bookmarks,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_FLASHCARD_BOOKMARK(bookmarks);
    }
  
    function removeFlashcardFromBookmark(id) {
      let bookmarks = _.cloneDeep(profile.flashcard_bookmarks);
      if (bookmarks) {
        bookmarks = bookmarks.filter(item => item != id);
      }
      const updatedProfile = {
        ...profile,
        flashcard_bookmarks: bookmarks,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_FLASHCARD_BOOKMARK(bookmarks);
    }
  
    function addFlashcardProgress(setId, cardId) {
      const data = {
        flashcard_set_id: setId,
        last_seen_flashcard_id: cardId,
      };
      let progress = _.cloneDeep(profile.flashcards_progress);
      if (progress) {
        progress = progress.filter(item => item.flashcard_set_id != data.flashcard_set_id);
        progress.push(data);
      } else {
        progress = [data];
      }
      const updatedProfile = {
        ...profile,
        flashcards_progress: progress,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_FLASHCARD_PROGRESS(progress);
    }
  
    function addQuestionToBookmark(id) {
      let bookmarks = _.cloneDeep(profile.question_bookmarks);
      if (bookmarks) {
        bookmarks.push(id);
      } else {
        bookmarks = [id];
      }
      const updatedProfile = {
        ...profile,
        question_bookmarks: bookmarks,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_QUESTION_BOOKMARK(bookmarks);
    }
  
    function removeQuestionFromBookmark(id) {
      let bookmarks = _.cloneDeep(profile.question_bookmarks);
      if (bookmarks) {
        bookmarks = bookmarks.filter(item => item != id);
      }
      const updatedProfile = {
        ...profile,
        question_bookmarks: bookmarks,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_QUESTION_BOOKMARK(bookmarks);
    }
  
    function addQuestionProgress(setId, questionId) {
      const data = {
        study_questions_set_id: setId,
        last_seen_question_id: questionId,
      };
      let progress = _.cloneDeep(profile.questions_progress);
      if (progress) {
        progress = progress.filter(item => item.study_questions_set_id != data.study_questions_set_id);
        progress.push(data);
      } else {
        progress = [data];
      }
      const updatedProfile = {
        ...profile,
        questions_progress: progress,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_QUESTION_PROGRESS(progress);
    }
  
    function addQuestionScore(question_id, topic_id, correct) {
      const domains = GET_APP_DOMAIN_LIST(selectedCertificate);
      
      let scores = questionScrore?.all_questions_scrores ?? [];
      const savedList = scores.filter(item => item.question_id == question_id);
      const saveItem = savedList.length > 0 ? savedList[0] : null;
      
      if (saveItem) {
        const score = correct ? saveItem.score + 1 : 0;
        const data = {
          question_id: question_id,
          topic_id: topic_id,
          times_answered: saveItem.times_answered + 1,
          last_seen: moment().format("YYYY MM DD HH:mm:ss"),
          score: score < 0 ? 0 : score,
          accuracy_score: score == 0 ? 0 : score == 1 ? 0.9 : 1,
        };
        SAVE_QUESTION(data);
        scores = scores.filter(item => item.question_id != question_id);
        scores.push(data);
      } else {
        const score = correct ? 1 : 0;
        const data = {
          question_id: question_id,
          topic_id: topic_id,
          times_answered: 1,
          last_seen: moment().format("YYYY MM DD HH:mm:ss"),
          score: score,
          accuracy_score: score == 1 ? 0.9 : 0,
        };
        SAVE_QUESTION(data);
        scores.push(data);
      }
  
      // Update question score state
      setQuestionScoreState({
        all_questions_scrores: scores,
      });
  
      // Calculate and update readiness scores
      const readinessScores = calculateReadinessScores(scores, questionsList, domains);
      const updatedProfile = {
        ...profile,
        readiness_scores: readinessScores,
        score_progress: {
          ...profile.score_progress,
          [moment().format("YYYY-MM-DD")]: readinessScores.readiness_score,
        }
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      
      SAVE_SCORE_PROGRESS(updatedProfile.score_progress);
      SAVE_PROGRESS_DASHBOARD(readinessScores);
  
      // Update community data
      const communityData = {
        question_id: question_id,
        topic_id: topic_id,
        correct: correct,
        questionsList: questionsList,
        app_domains: domains,
        scores: scores,
      };
      UPDATE_COMMUNITY_DATA(communityData);
    }
  
    function addAllQuestionScore(history) {
      const domains = GET_APP_DOMAIN_LIST(selectedCertificate);
      
      let scores = questionScrore?.all_questions_scrores ?? [];
      
      for (let index in history) {
        const obj = history[index];
        const savedList = scores.filter(item => item.question_id == obj.question_id);
        const saveItem = savedList.length > 0 ? savedList[0] : null;
        
        if (saveItem) {
          const score = obj.correct ? saveItem.score + 1 : 0;
          const data = {
            question_id: obj.question_id,
            topic_id: obj.topic_id,
            times_answered: saveItem.times_answered + 1,
            last_seen: moment().format("YYYY MM DD HH:mm:ss"),
            score: score < 0 ? 0 : score,
            accuracy_score: score == 0 ? 0 : score == 1 ? 0.9 : 1,
          };
          SAVE_QUESTION(data);
          scores = scores.filter(item => item.question_id != obj.question_id);
          scores.push(data);
        } else {
          const score = obj.correct ? 1 : 0;
          const data = {
            question_id: obj.question_id,
            topic_id: obj.topic_id,
            times_answered: 1,
            last_seen: moment().format("YYYY MM DD HH:mm:ss"),
            score: score,
            accuracy_score: score == 1 ? 0.9 : 0,
          };
          SAVE_QUESTION(data);
          scores.push(data);
        }
      }
  
      // Update question score state
      setQuestionScoreState({
        all_questions_scrores: scores,
      });
  
      // Calculate and update readiness scores
      const readinessScores = calculateReadinessScores(scores, questionsList, domains);
      
      // Handle case where profile might be null (for new users)
      const currentProfile = profile || {};
      const currentScoreProgress = currentProfile.score_progress || {};
      
      const updatedProfile = {
        ...currentProfile,
        readiness_scores: readinessScores,
        score_progress: {
          ...currentScoreProgress,
          [moment().format("YYYY-MM-DD")]: readinessScores.readiness_score,
        }
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      
      SAVE_SCORE_PROGRESS(updatedProfile.score_progress);
      SAVE_PROGRESS_DASHBOARD(readinessScores);
  
      // Update community data for all history
      for (let index in history) {
        const communityData = history[index];
        if (communityData.selected != STRING.unanswered_tag) {
          UPDATE_COMMUNITY_DATA(communityData);
        }
      }
    }
  
    function updateReadinessScore(data) {
      const readinessScores = calculateReadinessScores(data.scores, data.questionsList, data.app_domains);
      const updatedProfile = {
        ...profile,
        readiness_scores: readinessScores,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
    }
  
    function setCommunityData(data) {
      setCommunityState({
        questions_version: data.questions_version,
        total_time_per_question: data.total_time_per_question,
        android_app_verions: data?.android_app_verions,
        android_build_number: data?.android_build_number,
        ios_app_version: data?.ios_app_version,
        ios_build_number: data?.ios_build_number,
        is_forcefully_new_version: data?.is_forcefully_new_version,
      });
    }
  
    function setAllQuestionData(data) {
      setQuestionScoreState({
        all_questions_scrores: data,
      });
    }
  
    function setExamDate(date) {
      const updatedProfile = {
        ...profile,
        exam_date: date,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
    }
  
    // Article-related functions
    async function addArticleToBookmark(id) {
      console.log("addArticleToBookmark", id);
      let bookmarks = _.cloneDeep(articles.bookmarks || []);
      if (bookmarks) {
        bookmarks.push(id);
      } else {
        bookmarks = [id];
      }
      const updatedArticles = {
        ...articles,
        bookmarks: bookmarks,
      };
      setArticlesState(updatedArticles);
      updateArticlesLocalStorage(updatedArticles);
      
      // Save to Firebase
      try {
        await SAVE_ARTICLE_BOOKMARK(bookmarks);
      } catch (error) {
        console.error("Error saving article bookmark:", error);
      }
    }
  
    async function removeArticleFromBookmark(id) {
      console.log("removeArticleFromBookmark", id);
      let bookmarks = _.cloneDeep(articles.bookmarks || []);
      if (bookmarks) {
        bookmarks = bookmarks.filter(item => item != id);
      }
      const updatedArticles = {
        ...articles,
        bookmarks: bookmarks,
      };
      setArticlesState(updatedArticles);
      updateArticlesLocalStorage(updatedArticles);
      
      // Save to Firebase
      try {
        await SAVE_ARTICLE_BOOKMARK(bookmarks);
      } catch (error) {
        console.error("Error saving article bookmark:", error);
      }
    }
  
    function addArticleProgress(setId, articleId) {
      const data = {
        articles_set_id: String(setId),
        last_seen_article_id: articleId,
      };
      let progress = _.cloneDeep(profile.articles_progress);
      if (progress) {
        progress = progress.filter(item => String(item.articles_set_id) !== data.articles_set_id);
        progress.push(data);
      } else {
        progress = [data];
      }
      const updatedProfile = {
        ...profile,
        articles_progress: progress,
      };
      setProfileState(updatedProfile);
      updateLocalStorage(updatedProfile);
      SAVE_ARTICLE_PROGRESS(progress);
    }

    async function markArticleAsRead(articleId, articleData) {
      try {
        // Pass current summary from state to avoid reading from Firestore (optimization)
        const result = await MARK_ARTICLE_AS_READ(articleId, articleData, articles.readSummary);
        if (result.status) {
          // Update local articles state with new summary data
          const updatedArticles = {
            ...articles,
            readSummary: result.data.summary,
            // Note: Individual article data is handled by Firebase listener
          };
          setArticlesState(updatedArticles);
          updateArticlesLocalStorage(updatedArticles);
        }
        return result;
      } catch (error) {
        console.error("Error marking article as read:", error);
        return { status: false, error: error.message };
      }
    }

    async function getArticleReadStatus(articleId) {
      try {
        const result = await GET_ARTICLE_READ_STATUS(articleId);
        return result;
      } catch (error) {
        console.error("Error getting article read status:", error);
        return { status: false, error: error.message };
      }
    }

    async function getArticleReadSummary() {
      try {
        const result = await GET_ARTICLE_READ_SUMMARY();
        if (result.status) {
          // Update local articles state with summary data
          const updatedArticles = {
            ...articles,
            readSummary: result.data
          };
          setArticlesState(updatedArticles);
          updateArticlesLocalStorage(updatedArticles);
        }
        return result;
      } catch (error) {
        console.error("Error getting article read summary:", error);
        return { status: false, error: error.message };
      }
    }

    async function getReadArticlesByTopic(topicId) {
      try {
        const result = await GET_READ_ARTICLES_BY_TOPIC(topicId);
        return result;
      } catch (error) {
        console.error("Error getting read articles by topic:", error);
        return { status: false, error: error.message };
      }
    }

    async function getArticleBookmarks() {
      try {
        const result = await GET_ARTICLE_BOOKMARKS();
        if (result.status) {
          // Update local articles state with bookmarks data
          const updatedArticles = {
            ...articles,
            bookmarks: result.data
          };
          setArticlesState(updatedArticles);
          updateArticlesLocalStorage(updatedArticles);
        }
        return result;
      } catch (error) {
        console.error("Error getting article bookmarks:", error);
        return { status: false, error: error.message };
      }
    }

    // Article reaction functions
    async function likeArticle(articleId, topicId) {
      try {
        const result = await SAVE_ARTICLE_REACTION(articleId, 'like', { topic_id: topicId });
        if (result.status) {
          // Update local state with new reaction summary will be handled by Firebase listener
          console.log('Article liked:', articleId);
        }
        return result;
      } catch (error) {
        console.error("Error liking article:", error);
        return { status: false, error: error.message };
      }
    }

    async function dislikeArticle(articleId, topicId) {
      try {
        const result = await SAVE_ARTICLE_REACTION(articleId, 'dislike', { topic_id: topicId });
        if (result.status) {
          console.log('Article disliked:', articleId);
        }
        return result;
      } catch (error) {
        console.error("Error disliking article:", error);
        return { status: false, error: error.message };
      }
    }

    async function removeArticleReaction(articleId, topicId) {
      try {
        const result = await SAVE_ARTICLE_REACTION(articleId, null, { topic_id: topicId });
        if (result.status) {
          console.log('Article reaction removed:', articleId);
        }
        return result;
      } catch (error) {
        console.error("Error removing article reaction:", error);
        return { status: false, error: error.message };
      }
    }

    async function getArticleReactionSummary() {
      try {
        const result = await GET_ARTICLE_REACTION_SUMMARY();
        if (result.status) {
          // Update local articles state with reaction summary data
          const updatedArticles = {
            ...articles,
            reactionSummary: result.data
          };
          setArticlesState(updatedArticles);
          updateArticlesLocalStorage(updatedArticles);
        }
        return result;
      } catch (error) {
        console.error("Error getting article reaction summary:", error);
        return { status: false, error: error.message };
      }
    }

    // QOTD functions
    async function submitQOTDResponse(qotdResult) {
      try {
        const result = await UPDATE_USER_QOTD(qotdResult);
        return result;
      } catch (error) {
        console.error("Error submitting QOTD response:", error);
        return { status: false, error: error.message };
      }
    }

    async function getQOTDSummary() {
      try {
        const result = await GET_USER_QOTD_SUMMARY();
        return result;
      } catch (error) {
        console.error("Error getting QOTD summary:", error);
        return { status: false, error: error.message };
      }
    }

    async function getQOTDResponse(date) {
      try {
        const result = await GET_USER_QOTD_RESPONSE(date);
        return result;
      } catch (error) {
        console.error("Error getting QOTD response:", error);
        return { status: false, error: error.message };
      }
    }

    async function getQOTDResponses(startDate, endDate) {
      try {
        const result = await GET_USER_QOTD_RESPONSES(startDate, endDate);
        return result;
      } catch (error) {
        console.error("Error getting QOTD responses:", error);
        return { status: false, error: error.message };
      }
    }
  
    return (
      <AuthContext.Provider
        value={{
          user: auth().currentUser,
          isAuthenticated: auth().currentUser !== null,
          isAuthLoading,
          profile,
          articles,
          qotd,
          bundleData,
          community,
          questionsList,
          articlesList,
          flashCardsList,
          acronymsList,
          glossaryList,
          isSubscribe,
          isVisibleCommunity,
          questionScrore,
          setProfile,
          setBundleProfile,
          setNewProfile,
          setNewBundleProfile,
          setNotification,
          setProfileDetails,
          setProfilePicture,
          setBundleProfilePicture,
          setTestOptions,
          setSubscription,
          setTestHistory,
          deleteTestHistory,
          addFlashcardToBookmark,
          removeFlashcardFromBookmark,
          addFlashcardProgress,
          addQuestionToBookmark,
          removeQuestionFromBookmark,
          addQuestionProgress,
          addQuestionScore,
          addArticleToBookmark,
          removeArticleFromBookmark,
          addArticleProgress,
          markArticleAsRead,
          getArticleReadStatus,
          getArticleReadSummary,
          getArticleBookmarks,
          getReadArticlesByTopic,
          likeArticle,
          dislikeArticle,
          removeArticleReaction,
          getArticleReactionSummary,
          submitQOTDResponse,
          getQOTDSummary,
          getQOTDResponse,
          getQOTDResponses,
          setCommunityData,
          setQuestionsList,
          setArticles,
          addAllQuestionScore,
          getSubscriptionDetails,
          setVisibleCommunity,
          setFontsOptions,
          setAllQuestionData,
          updateReadinessScore,
          setExamDate
        }}
      >
        {props.children}
      </AuthContext.Provider>
    );
  };